export const BOOKING_HEADER_KEY = {
    id: 'bookingNo',
    bookingDate: 'bookingDate',
    travelDate: 'travelDate',
    firstName: 'firstName',
    lastName: 'lastName',
    amount: 'itemAmount',
    total: 'total',
    quantity: 'quantity',
    saleAccount: 'saleAccount'
}

export const CUSTOMER_HEADER_KEY = {
    id: 'CustomerID',
    firstName: 'name',
    lastName: 'lastname',
    email: 'email',
    nationality: 'nationality',
    registerDate: 'createdAt',
    status: 'status'
}

export const POCKET_HEADER_KEY = {
    id: 'id',
    firstName: 'firstName',
    lastName: 'lastName',
    activationDate: 'activationDate',
    currentBalance: 'currentBalance'
}

export const WRISTBAND_HEADER_KEY = {
    id: 'id',
    name: 'wristbandName',
    activationDate: 'activationDate',
    currentBalance: 'currentBalance'
}

export const TRANSACTION_HEADER_KEY = {
    refNo: 'refNo',
    date: 'date',
    detail: 'detail',
    amount: 'amount'
}

export const EVENT_HEADER_KEY = {
    startDate: 'startDate',
    customerName: 'customerName',
    member: 'member',
    createdBy: 'createdBy',
    status: 'status'
}

export const CUSTOMER_GROUP_KEY = {
    id: 'id',
    name: 'name',
    contact: 'contactName',
    phone: 'contactPhone'
}

export const PARTICIPANT_KEY = {
    name: 'name',
    phone: 'contactPhone',
    customer: 'customerName',
    registrationDate: 'registrationDate'
}

export const STAFF_KEY = {
    id: 'id',
    name: 'name',
    role: 'role'
}

export const IBEACON_MESSAGE_KEY = {
    id: 'id',
    topic: 'topic',
    dates: 'dates'
}

export const IBEACON_SETTING_KEY = {
    no: 'no',
    macAddress: 'macAddress',
    name: 'name',
    message: 'message'
}

export const SALE_AGENT_KEY = {
    createdAt: 'createdAt',
    name: 'name',
    organization: 'organization',
    email: 'email',
    phonenumber: 'phonenumber',
    subRoles: 'subRoles',
    isVerified: 'isVerified',
    isActive: 'isActive',
    totalTickets: 'totalTickets',
    totalAmount: 'totalAmount',
    totalCommission: 'totalCommission',
    isPaid: 'isPaid'

}

export const SALE_BOOKING_HISTORY_KEY = {
    bookingNo: 'bookingNo',
    staff: 'staff',
    tickets: 'tickets',
    amount: 'amount',
    amountCommission: 'amountCommission',
    isPaid: 'isPaid'
}
